import React, { useEffect, useState, useRef } from 'react';
import 'select2';
import FieldErrors from '../ErrorComponents/FieldErrors/FieldErrors';
import HelperText from '../FormElements/HelperText';

export default function Select2DropdownList(props) {
	const {
		name,
		value,
		style = {},
		fieldErrors = [],
		helperText = null,
		placeholder,
		dataPlaceholder,
		data,
		endpoint,
		isMulti,
		onChange
	} = props;

	const selectRef = useRef();
	const [
		select2Data,
		setSelect2Data
	] = useState([]);

	useEffect(
		() => {
			// Check if data is provided directly
			if (data) {
				const transformedData = data.map((d) => ({
					id: d.id || d.value || d.name,
					text: d.text || d.content || d.displayAs
				}));
				setSelect2Data(transformedData);
			} else if (endpoint) {
				// If data is not provided directly , fetch data using the provided endpoint
				$.ajax({
					type: 'GET',
					url: endpoint,
					dataType: 'json'
				}).done((response) => {
					const newData = response.data.map((d) => ({
						id: d.name,
						text: d.displayAs
					}));
					setSelect2Data(newData);
				});
			}
		},
		[
			data,
			endpoint
		]
	);

	useEffect(
		() => {
			initSelect2();

			return () => {
				destroySelect2();
			};
		},
		[
			select2Data
		]
	);

	useEffect(
		() => {
			// Check if the value has changed
			if (
				selectRef.current &&
				value !== undefined &&
				value !== selectRef.current.value
			) {
				// Update the selected values in the Select2DropdownList
				const selectedValue =
					value !== undefined && value !== null
						? isMulti ? value.map((v) => v.name) : value
						: null;
				$(selectRef.current).val(selectedValue).trigger('change');
			}
		},
		[
			value,
			isMulti
		]
	);

	function initSelect2() {
		const select2Options = {
			allowClear: true,
			width: '100%',
			placeholder: placeholder
				? placeholder
				: {
						id: '-1',
						text: dataPlaceholder
					},
			language: {
				searching: function() {
					return I18n.t('loading');
				}
			}
		};

		if (select2Data.length > 0) {
			if (isMulti) {
				select2Options.multiple = true;
			}
			select2Options.data = select2Data;
		}

		$(selectRef.current).select2(select2Options);

		// Update the selected values in the Select2DropdownList
		const selectedValue =
			value !== undefined && value !== null
				? isMulti ? value.map((v) => v.name) : value
				: null;
		$(selectRef.current).val(selectedValue).trigger('change');

		$(selectRef.current).on('select2:select', function(e) {
			onChange({
				isSelect2: true,
				target: {
					name: props.name,
					id: e.params.data.id,
					value: e.params.data.id,
					text: e.params.data.text
				}
			});
		});

		$(selectRef.current).on('select2:unselect', function(e) {
			onChange({
				isSelect2: true,
				isDeleted: true,
				target: {
					name: props.name,
					id: e.params.data.id,
					value: '',
					text: ''
				}
			});
		});
	}

	function destroySelect2() {
		$(selectRef.current).select2('destroy');
	}

	return (
		<div>
			<div style={{ position: 'relative' }}>
				<div style={style}>
					<select ref={selectRef} name={name} />
				</div>
			</div>
			<div>
				{fieldErrors && fieldErrors.hasOwnProperty(name) ? (
					<FieldErrors fieldName={name} fieldErrors={fieldErrors} />
				) : (
					<HelperText>{helperText}</HelperText>
				)}
			</div>
		</div>
	);
}
